import tv85 from "../../image/85 inches1.jpeg";
import Aircooler from "../../image/sdfsdf.jpg";
import Topwashing from "../../image/Untitled-1.jpg";
// import washing_machine from "../../image/Semi-Automatic-Washing-Machine-3.png";
import dishwasher from "../../image/09.jpg";
import ref from "../../image/08.jpg";
import Semiwashing from "../../image/SAC1.jpg";
import secondtv from "../../image/Bloom.png";
// import Aircooler from "../../image/Air Conditioner1.5.jpg";
import refri270 from "../../image/refris270L.jpg";

export const premiumData = [
  {
    id: 0,
    buyUrl: "https://gshoppi.com/product/6581387da02a3e7d21ac6d07",
    detailsUrl:
      "https://gplusindia.com/luxury-appliances/1/1/fully-touch%20panel-automatic-washing-machine-8.5kg",
    imageUrl: Topwashing,
  },
  {
    id: 1,
    buyUrl:
      "https://gshoppi.com/product/GPLUS-DISH-WASHER-16-PLACE-SETTINGS-black-(GM-DW-ULTRAX16)/658bbdfb0d16b48350c46ce4",
    detailsUrl: "https://gplusindia.com/luxury-appliances/5/1/dish-washer",
    imageUrl: dishwasher,
  },
  {
    id: 2,
    buyUrl:
      "https://gshoppi.com/product/GPLUS-528-L-FRENCH-DOOR-BOTTOM-FREZZER-Refrigerator-(Silver-GM-528W)/65eae981145ae609d59a8577",
    detailsUrl:
      "https://gplusindia.com/luxury-appliances/3/1/refrigerator-528L",
    imageUrl: ref,
  },
  {
    id: 3,
    buyUrl: "https://gshoppi.com/product/GPLUS-270l-Frost-Free-Refrigerator-with-Water-Dispenser-(GMF2700IWG-Grey)-Matt-Finish/677f878cdfe679a3050ff8ea",
    detailsUrl:
      "https://www.gplusindia.com/luxury-appliances/3/5/refrigerator-270L",
    imageUrl: refri270,
  },
  {
    id: 5,
    buyUrl:
      "https://gshoppi.com/product-category/4K-QLED-TV-55%2265%2275%2285%22?id=6777838adfe679a305024798",
    detailsUrl: "https://gplusindia.com/luxury-appliances/2",
    imageUrl: tv85,
  },
  {
    id: 4,
    buyUrl: "https://gshoppi.com/product/67e37e348b2fb7b692bfd8c6",
    detailsUrl: "https://gplusindia.com/luxury-appliances/7/2/air-cooler",
    imageUrl: Semiwashing,
  },

  

  {
    id: 6,
    buyUrl:
      "https://gshoppi.com/product/G-Plus-65L-Premium-Air-Cooler-High-Performance-Cooling-for-Ultimate-Comfort/67e382a68b2fb7b692c06e19",
    detailsUrl: "https://gplusindia.com/luxury-appliances/7/3/air-cooler",
    imageUrl: Aircooler,
  },
  {
    id: 7,
    buyUrl:
      "https://gshoppi.com/product/G-Plus-Bloom-3L-Air-Cooler-Efficient-Cooling-with-3L-Capacity/67e2eb978b2fb7b692be80e8",
    detailsUrl: "https://gplusindia.com/luxury-appliances/7/0/air-cooler",
    imageUrl: secondtv,
  },
  // {
  //     id: 5,
  //     url: "https://gshoppi.com/product/GPLUS-QLED-214-Cm-(85-Inches)-Ultra-HD-4K/65d9baf529cf4480e2ffdabc",
  //     imageUrl:refred
  // },
  // {
  //     id: 7,
  //     url: "https://gshoppi.com/product/GPLUS-QLED-214-Cm-(85-Inches)-Ultra-HD-4K/65d9baf529cf4480e2ffdabc",
  //     imageUrl: cooler1
  // },
];
